export { COPILOT_CHOICES } from "./choices";
export { COPILOT_INSTRUCTIONS } from "./top-level";
